export const SET_BRANDING = 'SET_BRANDING';
export const SET_BRANDING_LOGO = 'SET_BRANDING_LOGO';
export const SET_BRANDING_TENANT_UNIQUE_ID = 'SET_BRANDING_TENANT_UNIQUE_ID';
export const SET_ACTIVE_BRANDING_TENANT_ID = 'SET_ACTIVE_BRANDING_TENANT_ID';
export const SET_CENTRALISE_BRANDING = 'SET_CENTRALISE_BRANDING';
export const SET_BRANDING_LIST = 'SET_BRANDING_LIST';
